export const CLIENT = {
  client_id: process.env.REACT_APP_LOADSMART_CLIENT_ID,
}
